import React, { useState, useEffect } from 'react';
import axios from '../../api/axios';
import './Shared.css';

export default function Gradinite() {
  const [gradinite, setGradinite] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    nume: '',
    adresa: '',
    telefon: '',
    email: ''
  });

  useEffect(() => {
    fetchGradinite();
  }, []);

  const fetchGradinite = async () => {
    setLoading(true);
    try {
      const res = await axios.get('/api/admin/institutii?tip=gradinita');
      setGradinite(res.data);
    } catch (error) {
      console.error('Eroare:', error);
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({...prev, [name]: value}));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/admin/institutii', {
        ...formData,
        tip: 'gradinita'
      });
      setFormData({ nume: '', adresa: '', telefon: '', email: '' });
      setShowForm(false);
      fetchGradinite();
    } catch (error) {
      alert('Eroare: ' + error.response?.data?.message);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Esti sigur?')) {
      try {
        await axios.delete(`/api/admin/institutii/${id}`);
        fetchGradinite();
      } catch (error) {
        alert('Eroare: ' + error.response?.data?.message);
      }
    }
  };

  return (
    <div className="admin-section">
      <div className="section-header">
        <h1>Gradinite</h1>
        <button onClick={() => setShowForm(!showForm)} className="btn btn-primary">
          + Adaugă Gradinita
        </button>
      </div>

      {showForm && (
        <div className="form-card">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Nume *</label>
              <input type="text" name="nume" value={formData.nume} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Adresa</label>
              <input type="text" name="adresa" value={formData.adresa} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Telefon</label>
              <input type="tel" name="telefon" value={formData.telefon} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" name="email" value={formData.email} onChange={handleChange} />
            </div>
            <div className="form-buttons">
              <button type="submit" className="btn btn-success">Salveaza</button>
              <button type="button" onClick={() => setShowForm(false)} className="btn btn-secondary">Anuleaza</button>
            </div>
          </form>
        </div>
      )}

      <div className="cards-grid">
        {gradinite.map(gradinita => (
          <div key={gradinita._id} className="card">
            <h3>{gradinita.nume}</h3>
            <p><strong>Adresa:</strong> {gradinita.adresa || '-'}</p>
            <p><strong>Telefon:</strong> {gradinita.telefon || '-'}</p>
            <p><strong>Email:</strong> {gradinita.email || '-'}</p>
            <p><strong>ID:</strong> <code>{gradinita._id}</code></p>
            <div className="card-actions">
              <button onClick={() => handleDelete(gradinita._id)} className="btn btn-danger btn-sm">Sterge</button>
            </div>
          </div>
        ))}
      </div>

      {gradinite.length === 0 && !loading && <p className="empty-message">Nu sunt gradinite inregistrate.</p>}
    </div>
  );
}
